import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import './Expense.scss';
import { ExpenseInputSelector, setTriggerRefreshInput, setTriggerSave } from './reducers/ExpenseInputReducer';
import { resetExpenseSearch, resetQuery, setComponentType, setExpenseSearchResults, setSearchResultTotalRecord, setTriggerExpenseSearch } from './reducers/ExpenseSearchReducer';
import ExpenseInput from './ExpenseInput';
import ExpenseTable from './ExpenseTable';

let triggerHotkeyAlready = false;

interface ExpenseProp {
    type: string
}

const Expense: React.FunctionComponent<ExpenseProp> = (props) => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);
    const ExpenseInputViewData = useSelector(ExpenseInputSelector);

    useEffect(() => {
        document.title = props.type;

        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);
    }, []);

    const handleKeyPress = useCallback((event) => {
        if (!triggerHotkeyAlready) {
            if (event.altKey) {
                switch (event.key) {
                    case "s":
                        //save
                        triggerHotkeyAlready = true;
                        dispatch(setTriggerSave((new Date()).getTime()));
                        break;
                    case "r":
                        //refresh save
                        dispatch(setTriggerRefreshInput((new Date()).getTime()));
                        break;
                    default:
                        break;
                }
            }

            setTimeout(() => {
                triggerHotkeyAlready = false;
            }, 2000);
        }
    }, []);

    return (
        <>
            <Grid container className="tonnage">
                <Grid container className="input-fields">
                    <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                        <ExpenseInput></ExpenseInput>
                    </div>
                </Grid>
                <Grid container className="datatable">
                    <ExpenseTable>
                    </ExpenseTable>
                </Grid>
            </Grid>
        </>
    )
};

export default Expense;